// import React from "react";
// import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faHome, faBolt, faCommentDots, faBars } from "@fortawesome/free-solid-svg-icons";

// export default function Footer() {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         bottom: 0,
//         width: "100%",
//         backgroundColor: "#fff",
//         borderTop: "1px solid #ccc",
//         display: "flex",
//         justifyContent: "space-around",
//         padding: "10px 0",
//         zIndex: 1000,
//       }}
//     >
//       <Link to="/" style={{ textAlign: "center", textDecoration: "none", color: "#555" }}>
//         <FontAwesomeIcon icon={faHome} size="lg" />
//         <div>Home</div>
//       </Link>

//       <Link to="/leaderboard" style={{ textAlign: "center", textDecoration: "none", color: "#555" }}>
//         <FontAwesomeIcon icon={faBolt} size="lg" />
//         <div>Leaderboard</div>
//       </Link>

//       <Link to="/feedback" style={{ textAlign: "center", textDecoration: "none", color: "#555" }}>
//         <FontAwesomeIcon icon={faCommentDots} size="lg" />
//         <div>Feedback</div>
//       </Link>

//       <Link to="/menu" style={{ textAlign: "center", textDecoration: "none", color: "#555" }}>
//         <FontAwesomeIcon icon={faBars} size="lg" />
//         <div>Menu</div>
//       </Link>
//     </div>
//   );
// }

import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Footer.css";
import { faHome, faBolt, faCommentDots, faBars } from "@fortawesome/free-solid-svg-icons";

export default function Footer() {
  return (
    <footer className="footer">
      <Link to="/profile" className="footer-link">
        <FontAwesomeIcon icon={faHome} size="lg" />
        <div>Home</div>
      </Link>

      <Link to="/leaderboard" className="footer-link">
        <FontAwesomeIcon icon={faBolt} size="lg" />
        <div>Leaderboard</div>
      </Link>

      <Link to="/feedback" className="footer-link">
        <FontAwesomeIcon icon={faCommentDots} size="lg" />
        <div>Feedback</div>
      </Link>

      <Link to="/menu" className="footer-link">
        <FontAwesomeIcon icon={faBars} size="lg" />
        <div>Menu</div>
      </Link>
    </footer>
  );
}

